import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Badge, Table, Alert, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faPencilAlt, faFileImport } from '@fortawesome/free-solid-svg-icons';
import DashboardLayout from './DashboardLayout';
import ReducedContent from './ReducedContent';
import { fetchCategories, deleteCategory } from '../../api/api';

const CategoryList = () => {
  const [pageMessage, setPageMessage] = useState("Buscando categorias...");
  const [categoriesGroupedBySubject, setCategoriesGroupedBySubject] = useState(null);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchCategories();
        if (!response.length) return setPageMessage("Nenhuma categoria encontrada");

        const groupedData = response.sort((a, b) => a.subject_name.localeCompare(b.subject_name) || a.grade_name.localeCompare(b.grade_name))
          .reduce((acc, item) => {
            acc[item.subject_name] = acc[item.subject_name] || {};
            acc[item.subject_name][item.grade_name] = acc[item.subject_name][item.grade_name] || [];
            acc[item.subject_name][item.grade_name].push(item);
            return acc;
          }, {});

        setCategoriesGroupedBySubject(groupedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleDelete = async (category_uuid) => {
    try {
      await deleteCategory(category_uuid) ? setShowSuccessAlert(true) : setShowErrorAlert(true);
    } catch (error) {
      console.error("Error deleting data:", error);
    }
    setTimeout(() => { setShowSuccessAlert(false); setShowErrorAlert(false); }, 3000);
  };

  const handleEdit = (subject_uuid) => navigate('/dashboard/category/' + subject_uuid + '/edit');

  return (
    <DashboardLayout title="Categorias">
      <ReducedContent>
        {showSuccessAlert && <Alert variant="success">Categoria deletada com sucesso!</Alert>}
        {showErrorAlert && <Alert variant="danger">Erro ao deletar categoria.</Alert>}

        {categoriesGroupedBySubject ? Object.entries(categoriesGroupedBySubject).map(([subject_name, grades]) => (
          <div key={subject_name}>
            <h4><FontAwesomeIcon icon={faFileImport} /> {subject_name}</h4>
            {Object.entries(grades).map(([grade, categories]) => (
              <div key={grade}>
                <br />
                <h6>{grade}</h6>
                <Table hover responsive>
                  <colgroup>
                    <col style={{ width: '5%' }} />
                    <col style={{ width: '50%' }} />
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '25%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nome</th>
                      <th>Atividades</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((category, index) => (
                      <tr key={category.uuid}>
                        <td>{index + 1}</td>
                        <td>{category.name}</td>
                        <td><Badge bg="primary">{category.activity_count}</Badge></td>
                        <td>
                          <Button
                            variant={category.read_only ? "outline-secondary" : "outline-primary"}
                            size="sm"
                            onClick={() => handleEdit(category.uuid)}
                            disabled={category.read_only}
                            title={category.read_only ? "Read-only" : "Edit"}
                          >
                            <FontAwesomeIcon icon={faPencilAlt} />
                          </Button>{' '}
                          <Button
                            variant={category.read_only ? "outline-secondary" : "outline-danger"}
                            size="sm"
                            onClick={() => handleDelete(category.uuid)}
                            disabled={category.read_only}
                            title={category.read_only ? "Read-only" : "Delete"}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ))}
            <br />
            <br />
          </div>
        )) : <p>{pageMessage}</p>}
      </ReducedContent>
    </DashboardLayout>
  );
};

export default CategoryList;
